import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isAuth } from "./helpers/helpers";

const App = () => {
	const navigate = useNavigate()
	useEffect(() => {
		if (isAuth()) {
			navigate('/prematch/arbitrage');
		}
		else{
			navigate('/signin');
		}
	}, [])
	// This component is no longer used as a landing page.
	// It only redirects authenticated users to the main app.
	return null;
}

export default App;
